/*
 * @Author: yangyang yyangacom@163.com
 * @Date: 2023-06-07 16:47:37
 * @LastEditors: yangyang yyangacom@163.com
 * @LastEditTime: 2023-09-17 12:52:26
 * @FilePath: /dbrank_b/src/routes/visualChart/P1/index.js
 * @Description: p1
 */
import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './index.css';
import Stage from '../components/Stage';
import setChart from './chart';
import Chart from '../components/Chart';
import { Title4 } from '../components/Titles';
import TooltipDrawer from '../components/TooltipDrawer';
import Form from './Form';
import DBTable from '../components/DBTable';
import { applyThousands } from '../utils';

class P14 extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      chartTitle: [],
      chartList: [],

      tableColumns: [],
      tableList: [],
      tableColorList: [],
    }
  }

  fillColor = (tableColumns, tableColorList) => {
    const border = `2px solid ${tableColorList[2]}`
    return tableColumns.map(item => {
      return {
        ...item,
        style: {
          ...item.style,
          height: 28,
          fontSize: 16,
          fontWeight: 500,
          textAlign: 'center',
          background: tableColorList[0],
          color: tableColorList[1],
          borderRight: border,
          borderBottom: border,
        },
        colStyle: {
          height: 28,
          fontSize: 16,
          fontWeight: 500,
          textAlign: 'center',
          borderRight: border,
          borderBottom: border,
          background: tableColorList[0],
        }
      }
    })
  }

  render() {
    const { chartTitle, chartList, tableColumns, tableList, tableColorList } = this.state;
    const border = `2px solid ${tableColorList[2]}`

    return (
      <Stage>
        <Title4 pageNumber="3.5">安踏VS竞品 | 社交平台全年传播效果-<span className={s.titleHint}>微博</span></Title4>

        <div className={s.content}>
          <div>
            <div contentEditable className={s.subTitle}>
            安踏数字品牌价值排名第三；各品牌的爆款文章多来自品牌代言人发博，获得较高热度
            </div>
            <div contentEditable className={s.des}>
            李宁在微博上的内容数量、互动量和数字品牌价值都最高，斐乐和安踏依次排名第二、第三名。特步的DB总值主要来自代言人发博的贡献。
            </div>
            <div contentEditable className={s.des}>
            在微博平台的TOP20内容列表中，李宁有11条入选，其中一篇为官方发声，明星发博为其“2022逐梦行”主题秀宣传效果显著。
            </div>
          </div>
          <div className={s.uiWrapper}>
            <div className={s.chartWrapper}>
              <Chart isShow options={setChart({ title: chartTitle, list: chartList, color: tableColorList.slice(3) })} />
            </div>

            <div className={s.tableWrapper}>
              <TooltipDrawer formContent={<Form onChange={values => this.setState({ ...values })} />}>
                <DBTable
                  columns={this.fillColor(tableColumns, tableColorList)}
                  data={applyThousands(tableList)}
                  style={{
                    boxShadow: 'none',
                    borderTop: border,
                    borderLeft: border,
                  }}
                />
              </TooltipDrawer>
            </div>
          </div>
        </div>
      </Stage>
    );
  }
}

export default withStyles(s)(P14);



// WEBPACK FOOTER //
// src/routes/visualChart/P14/index.js